// extracted by mini-css-extract-plugin
export var label = "_g0-2";
export var slideContainer = "_g0-0";
export var slider = "_g0-1";